import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import { IRetrySubscriptionPaymentResponse, retrySubscriptionPayment } from "../actions/retryRenewalSubscription";
import { EQueryKeys } from "./useMySubscriptionInfo.query";

export const useRetrySubscriptionPayment = (options?: UseMutationOptions<IRetrySubscriptionPaymentResponse, Error, string>) => {
  const queryClient = useQueryClient();

  return useMutation<IRetrySubscriptionPaymentResponse, Error, string>({
    mutationKey: ["retry-subscription-payment"],
    mutationFn: retrySubscriptionPayment,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [EQueryKeys.MY_SUBSCRIPTION_INFO],
      });
    },
    ...options,
  });
};
